import useSWR from "swr"

import { alfredDeviceService } from "@/services/alfred-device-service"
import type {
  AlfredBulkImportJobStatus,
  AlfredBulkImportJobStatusResponse,
} from "@/types/alfred-bulk-import"

export const ALFRED_BULK_IMPORT_POLL_INTERVAL_MS = 2_500

const TERMINAL_STATUSES = new Set<AlfredBulkImportJobStatus>([
  "COMPLETED",
  "COMPLETED_WITH_ERRORS",
  "FAILED",
])

export function isAlfredBulkImportTerminal(status: AlfredBulkImportJobStatus): boolean {
  return TERMINAL_STATUSES.has(status)
}

export function getAlfredBulkImportRefreshInterval(
  latestJob?: AlfredBulkImportJobStatusResponse,
): number {
  return latestJob && isAlfredBulkImportTerminal(latestJob.status)
    ? 0
    : ALFRED_BULK_IMPORT_POLL_INTERVAL_MS
}

export function useAlfredBulkImportJob(jobId: string | null) {
  return useSWR(
    jobId ? ["alfred", "bulk-import", jobId] : null,
    () => alfredDeviceService.getBulkImportJob(jobId as string),
    {
      refreshInterval: getAlfredBulkImportRefreshInterval,
      errorRetryInterval: ALFRED_BULK_IMPORT_POLL_INTERVAL_MS,
      revalidateOnFocus: false,
    },
  )
}
